import {
  useGetMeetingsQuery,
  useLazyGetMeetingsQuery,
  useLazyGetMeetingQuery,
} from 'features/meetings/graphql_api'

const EMPTY_QUERY_VARS = {}

export const useLegacyMeetingSearchQueries = ({
  skipQueries,
  isSupergraphEnabled,
  shouldLoadToday,
  filters,
  visibleRangeQueryVariables,
  queryOptions,
  backgroundPollingConfig,
  visibleRangePollingInterval,
}) => {
  const futureSearchApiVars = filters ? { ...filters, order: 'ASC' } : null

  const futureSearchApi = useGetMeetingsQuery(
    futureSearchApiVars || {},
    {
      skip: skipQueries || isSupergraphEnabled,
      ...queryOptions,
    },
  )

  const todaySearchApiVars = filters ? { ...filters, today: true } : null

  const todaySearchApi = useGetMeetingsQuery(
    todaySearchApiVars || {},
    {
      skip: skipQueries || !shouldLoadToday || isSupergraphEnabled,
      ...queryOptions,
    },
  )

  const pastSearchApiVars = filters ? { ...filters, past: true, order: 'DESC' } : null

  const pastSearchApi = useGetMeetingsQuery(
    pastSearchApiVars || {},
    {
      skip: skipQueries || isSupergraphEnabled,
      ...queryOptions,
    },
  )

  const visibleRangeArgs = visibleRangeQueryVariables ?? EMPTY_QUERY_VARS
  const { data: visibleRangeDataSearch } = useGetMeetingsQuery(visibleRangeArgs, {
    ...backgroundPollingConfig,
    pollingInterval: visibleRangePollingInterval,
    skip: !visibleRangeQueryVariables || isSupergraphEnabled,
    refetchOnMountOrArgChange: false,
    refetchOnFocus: false,
    refetchOnReconnect: false,
  })

  const [triggerSearchApi, resultSearchApi] = useLazyGetMeetingsQuery()
  const [triggerVisibleRangeNextSearchApi, visibleRangeNextResultSearchApi] = useLazyGetMeetingsQuery()
  const [triggerMeetingSearchApi] = useLazyGetMeetingQuery()

  return {
    futureSearchApi,
    todaySearchApi,
    pastSearchApi,
    visibleRangeDataSearch,
    triggerSearchApi,
    resultSearchApi,
    triggerVisibleRangeNextSearchApi,
    visibleRangeNextResultSearchApi,
    triggerMeetingSearchApi,
  }
}
